module.exports = __webpack_public_path__ + "static/img/register-logo.af3a7f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/register-logo.png
// module id = J5Iw
// module chunks = 16